/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of a transfer.
 */
export const TransferStatus = {
  Created: "created",
  Pending: "pending",
  Completed: "completed",
  Failed: "failed",
  Reversed: "reversed",
  Queued: "queued",
  Canceled: "canceled",
} as const;
/**
 * Status of a transfer.
 */
export type TransferStatus = ClosedEnum<typeof TransferStatus>;

/** @internal */
export const TransferStatus$inboundSchema: z.ZodNativeEnum<
  typeof TransferStatus
> = z.nativeEnum(TransferStatus);
/** @internal */
export const TransferStatus$outboundSchema: z.ZodNativeEnum<
  typeof TransferStatus
> = TransferStatus$inboundSchema;
